require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-modernization-of-rani-jamara-kulariya-irrigation-scheme.json") })
        }
      }, "path---en-us-project-modernization-of-rani-jamara-kulariya-irrigation-scheme");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-modernization-of-rani-jamara-kulariya-irrigation-scheme!./.cache/json/en-us-project-modernization-of-rani-jamara-kulariya-irrigation-scheme.json
// module id = 543
// module chunks = 231608221292675